import { supabase } from '../supabase';

export interface WorkspaceProfilesResult {
  workspaceProfiles: any[];
  isInternal: boolean;
}

// Get all workspace_profiles for the current authenticated user and return it inside user (authStore.ts).
export async function fetchWorkspaceProfilesForUser(): Promise<WorkspaceProfilesResult | null> {
  const {
    data: { user },
    error: authError,
  } = await supabase.auth.getUser();

  if (authError || !user) {
    console.error('Not authenticated');
    return null;
  }

  try {
    const [workspacesResult, profileResult] = await Promise.all([
      supabase
        .from('workspace_profiles')
        .select(
          `
          workspace_id,
          role:workspace_roles(name),
          workspaces (
            id,
            name,
            created_by,
            is_template,
            ps_token_balance,
            ps_token_total,
            ps_token_expiry,
            daily_ps_token_limit
          )
        `,
        )
        .eq('profile_id', user.id),
      supabase
        .from('profiles')
        .select('is_internal')
        .eq('id', user.id)
        .single(),
    ]);

    if (workspacesResult.error) {
      console.error(
        'Error fetching workspace_profiles:',
        workspacesResult.error,
      );
      return null;
    }

    if (profileResult.error) {
      console.error('Error fetching profile is_internal:', profileResult.error);
      return {
        workspaceProfiles: workspacesResult.data ?? [],
        isInternal: false,
      };
    }

    return {
      workspaceProfiles: workspacesResult.data ?? [],
      isInternal: profileResult.data?.is_internal ?? false,
    };
  } catch (err) {
    console.error('Unexpected error fetching workspace_profiles:', err);
    return null;
  }
}
